import React, { useState } from "react";
import TableView from "./table/table-view";
import Button from "../../../components/buttons/button";
import CreateAnnouncementModal from "./table/components/create-announcement-modal";
import TablePaginationCustom from "../user-events/table/table-pagination-custom";
import TableFilters from "../user-events/table/table-filters";
import { useGetannouncementQuery } from "../../../store/Reducer/annocements";
import { useTranslation } from "react-i18next";

const AllAnnouncements = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");

  const {
    data: annocementsdata,
    isLoading,
    error,
  } = useGetannouncementQuery({ page: currentPage, search });

  const TABLE_HEAD = [
    { id: "title", label: "Announcement" },
    { id: "message", label: "Message" },
    { id: "shows", label: "Shows" },
    { id: "status", label: "Status" },
    { id: "action", label: "" },
  ];

  const openModal = (edit = false, rowData = null) => {
    setIsEdit(edit);
    setSelectedRowData(rowData);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsEdit(false);
    setSelectedRowData(null);
    setIsOpen(false);
  };

  return (
    <>
      <div className="content mt-6">
        <div className="mb-2 header flex justify-between items-center flex-wrap gap-3">
          <h2 className="text-xl sm:text-2xl text-gray-800 text-start font-semibold">
            {t("all_announcements_title")}
          </h2>
          <Button
            text={t("all_announcements_btn_text")}
            type="button"
            className="px-6 text-nowrap"
            onClick={() => openModal(false)}
          />
        </div>
        <TableFilters search={search} setSearch={setsearch} />

        {isLoading ? (
          <div className="pt-16 flex justify-center mt-12 items-center">
            <div
              className="animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-gray-700 dark:text-gray-100 rounded-full"
              role="status"
              aria-label="loading"
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <TableView
              annocementsdata={annocementsdata?.data || []}
              TABLE_HEAD={TABLE_HEAD}
              onEditRow={(rowData) => openModal(true, rowData)} // Handle edit action
              searching={Boolean(search)}
            />
            <TablePaginationCustom
              details={annocementsdata?.pagination || []}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage} // Pass page setter to pagination component
              totalItems={annocementsdata?.pagination?.totalAnnouncements}
              totalPages={annocementsdata?.pagination?.totalPages || 1} // Pass the total pages to the pagination component
            />
          </>
        )}
      </div>

      <CreateAnnouncementModal
        isOpen={isOpen}
        closeModal={closeModal}
        isEdit={isEdit}
        rowData={selectedRowData}
      />
    </>
  );
};

export default AllAnnouncements;
